import { useEffect, useState } from "react";

export const useAudioLevel = (stream) => {
  const [level, setLevel] = useState(0);

  useEffect(() => {
    if (!stream || typeof window === "undefined") {
      setLevel(0);
      return undefined;
    }

    const AudioContextCtor = window.AudioContext || window.webkitAudioContext;

    if (!AudioContextCtor) {
      setLevel(0);
      return undefined;
    }

    const context = new AudioContextCtor();
    const analyser = context.createAnalyser();
    const source = context.createMediaStreamSource(stream);
    const dataArray = new Uint8Array(256);
    let frameId = 0;
    let disposed = false;

    analyser.fftSize = 256;
    analyser.smoothingTimeConstant = 0.85;
    source.connect(analyser);
    void context.resume?.();

    const tick = () => {
      if (disposed) {
        return;
      }

      analyser.getByteTimeDomainData(dataArray);

      let sum = 0;
      for (let index = 0; index < dataArray.length; index += 1) {
        const centeredSample = (dataArray[index] - 128) / 128;
        sum += centeredSample * centeredSample;
      }

      const rms = Math.sqrt(sum / dataArray.length);
      const normalized = Math.min(1, rms * 3.4);

      setLevel((previous) => (previous * 0.6 > normalized ? previous * 0.6 : normalized));
      frameId = window.requestAnimationFrame(tick);
    };

    tick();

    return () => {
      disposed = true;
      window.cancelAnimationFrame(frameId);
      source.disconnect();
      analyser.disconnect();
      void context.close();
      setLevel(0);
    };
  }, [stream]);

  return level;
};
